<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "TheMeetingRecordBookStudent",

  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      recordBooks: [],
      loading: false,
      headers: [
        {text: 'Дисциплина', value: 'subject'},
        { text: 'Преподаватель', value: 'teacher' },
        { text: 'Тип контроля', value: 'type_of_the_control' },
        { text: 'Оценка', value: 'mark' },
        { text: 'Дата', value: 'date' },
      ],
    }
  },

  computed: {
    ...mapState({
      statement: state => state.scholarship_competition.statement,
      meeting: state => state.scholarship_meeting.meeting,
    }),
  },

  watch: {
    visible: async function () {
      if (this.visible) {
        const [response, error] = await this.getRecordBookStudent(229);
        if (error != null) {
          console.log(error);
          return
        }
        this.recordBooks = response
      } else {
        this.recordBooks = []
      }
    }
  },

  methods: {
    async getRecordBookStudent() {
      this.loading = true;
      try {
        const response = await axios.get(`/scholarship/meeting/meetings/${this.meeting.id}/competitions/${this.statement.id}/student_record_books`);
        return  [response.data, null];
      } catch (e) {
        console.log(e);
        return [null, e]
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getUTCDate();
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear();

      const formatNumber = num => num.toString().padStart(2, '0');
      return `${formatNumber(day)}.${formatNumber(month)}.${year}`;
    }
  }
}
</script>

<template>
  <v-dialog
      :value="visible"
      @input="$emit('close')"
      content-class="rounded-xl"
      fullscreen
  >
    <v-card v-if="visible">
      <v-card-title>
        <span>Зачетные книжки студента</span>
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>fa fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="loading" class="d-flex justify-center align-center">
        <v-progress-circular
            indeterminate
            size="64"
            color="teal darken-3"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-else>
        <v-expansion-panels>
          <v-expansion-panel v-for="recordBook in recordBooks" :key="recordBook.record_book_name">
            <v-expansion-panel-header v-html="'Номер зачетной книжки: ' + recordBook.record_book_name"/>
            <v-expansion-panel-content>
              <v-expansion-panels>
                <v-expansion-panel v-for="record in recordBook.records" :key="`${recordBook.record_book_name},${record.term}`">
                  <v-expansion-panel-header v-html="record.term"/>
                  <v-expansion-panel-content>
                    <v-data-table
                        :headers="headers"
                        group-by="type_of_the_control"
                        :items="record.marks"
                    >
                      <template #item.date="{item}">
                        {{formatDate(item.date)}}
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>